import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { Proposal } from "../../models";
import { RQ } from "../../globals/enums";
import { remove } from "../../api/generic-api";
import { deleteEntity } from "../../utils";

export const useDeleteProposal = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("proposals", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Proposal Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.PROPOSALS,
        (proposals: Proposal[] | undefined) => {
          return !proposals ? [] : deleteEntity<Proposal>(proposals, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Proposal Deleting Error", { variant: "error" });
    },
  });
};
